import * as React from 'react'


interface ArticleProps {
  article: any
  onClick: (id: number) => void
}

interface ArticleState {

}


class Article extends React.Component<ArticleProps, ArticleState> {

  handleArticleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    this.props.onClick(this.props.article.id)
  }

  handleArticleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.props.onClick(this.props.article.id)
    }
  }

  render () {
    return (
      <li
        className='list-group-item'
        onClick={this.handleArticleClick}
        role='link'
        tabIndex={0}
        onKeyDown={this.handleArticleKeyDown}
      >
        <a className='answers-popular-item-header' href='#'>{this.props.article.text}</a>
      </li>
    )
  }
}

export {
  Article
}
